export const LANDING_PAGE_TITLE = "title.landing";

export const LANDING_PAGE_PATH = "/home";
